var map = {
	"./000---PrisonStart.json": 36098,
	"./001---PrisonCourtyard.json": 52643,
	"./002---SewerShort.json": 15406,
	"./003---PrisonDepths.json": 37895,
	"./004---PrisonCorrupt.json": 20954,
	"./005---PrisonRoof.json": 97809,
	"./006---Ossuary.json": 30603,
	"./007---SewerDepths.json": 81631,
	"./008---Bridge.json": 55473,
	"./009---BeholderPit.json": 82604,
	"./010---StiltVillage.json": 34682,
	"./011---AncientTemple.json": 81713,
	"./012---Cemetery.json": 38932,
	"./013---ClockTower.json": 95489,
	"./014---Crypt.json": 46431,
	"./015---TopClockTower.json": 33923,
	"./016---Cavern.json": 94992,
	"./017---Giant.json": 32522,
	"./018---Castle.json": 10265,
	"./019---Distillery.json": 17173,
	"./020---Throne.json": 93186,
	"./021---Astrolab.json": 87900,
	"./022---Observatory.json": 78785,
	"./023---IllegalLevel.json": 46126,
	"./024---BoatDock.json": 69073,
	"./025---Greenhouse.json": 36780,
	"./026---Swamp.json": 58333,
	"./027---SwampHeart.json": 21218,
	"./028---Tumulus.json": 92869,
	"./029---Cliff.json": 94791,
	"./030---GardenerStage.json": 44246,
	"./031---Shipwreck.json": 68453,
	"./032---Lighthouse.json": 18206,
	"./033---QueenArena.json": 90387,
	"./034---Bank.json": 6306,
	"./035---PurpleGarden.json": 27321,
	"./036---DookuCastle.json": 61778,
	"./037---DookuCastleHard.json": 39680,
	"./038---DeathArena.json": 33021,
	"./039---DookuArena.json": 72153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54711;